import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { Button } from '@noths/polaris-design-system-core-components';

import {
  ADD_TO_BASKET_CTA,
  ADDING_TO_BASKET_CTA,
  BUY_GIFT_CARD_CTA,
  EDIT_PERSONALISATION_CTA,
  SAVING_PERSONALISATION_CTA,
} from './copy';
import { MAIN_PAGE_CTA_ID } from './elementIDs';
import * as styles from './BasketCTAButton.styles';

export interface BasketCTAButtonDispatchProps {
  onAddEditClick: VoidFunction;
  onBuyGiftCard: (ev: React.MouseEvent) => void;
  onVisible: () => void;
}

export interface BasketCTAButtonStateProps {
  editMode: boolean;
  loading: boolean;
  purchasable: boolean;
}

type BasketCTAButtonProps = BasketCTAButtonDispatchProps & BasketCTAButtonStateProps;

export const BasketCTAButton = ({
  editMode,
  loading,
  onAddEditClick,
  onBuyGiftCard,
  onVisible,
  purchasable,
}: BasketCTAButtonProps) => {
  const rootRef = useImpressionRef<HTMLDivElement>(() => onVisible());
  const purchasableCTAText = loading
    ? editMode
      ? SAVING_PERSONALISATION_CTA
      : ADDING_TO_BASKET_CTA
    : editMode
    ? EDIT_PERSONALISATION_CTA
    : ADD_TO_BASKET_CTA;

  return (
    <div css={[styles.ctaSectionWrapper]} ref={rootRef}>
      {purchasable ? (
        <Button
          disabled={loading}
          id={MAIN_PAGE_CTA_ID}
          onClick={() => onAddEditClick()}
          type="button"
        >
          {purchasableCTAText}
        </Button>
      ) : (
        <Button href="/gift-cards" id={MAIN_PAGE_CTA_ID} onClick={onBuyGiftCard}>
          {BUY_GIFT_CARD_CTA}
        </Button>
      )}
    </div>
  );
};
